
    import {
        defineComponent, PropType,
    } from 'vue';

    export default defineComponent({
        name: 'railway-tours-tab',
        props: {
            isActive: {
                type: Boolean as PropType<boolean>,
            },
        },
    });
